import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src/index';

/**
 * Block initializations
 */
export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const bm = editor.BlockManager;

  bm.add(window.PMW.emails.blocks.ID_SECTION_PRESET_1, {
    activate: true,
    category: window.PMW.emails.blocks.CATEGORY_SECTIONS,
    label: window.i18next.t('pmwjs_section'),
    // trackingEvent: 'EmailMaker_AddSection', // Tracking temporarily disabled on 8th Nov 2023
    select: true,
    content: {
      type: window.PMW.emails.components.table.PMW_SECTION,
      [window.PMW.emails.props.COLUMNS_PRESET]: 1,
      [window.PMW.emails.props.APPLY_INITIAL_PRESET]: true,
    },
    attributes: {
      trackingEvent: 'EmailMaker_AddSection',
      sortPriority: 0,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_SECTION_PRESET_2, {
    activate: true,
    category: window.PMW.emails.blocks.CATEGORY_SECTIONS,
    label: window.i18next.t('pmwjs_section'),
    // trackingEvent: 'EmailMaker_AddSection', // Tracking temporarily disabled on 8th Nov 2023
    select: true,
    content: {
      type: window.PMW.emails.components.table.PMW_SECTION,
      [window.PMW.emails.props.COLUMNS_PRESET]: 2,
      [window.PMW.emails.props.APPLY_INITIAL_PRESET]: true,
    },
    attributes: {
      trackingEvent: 'EmailMaker_AddSection',
      sortPriority: 1,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_SECTION_PRESET_3, {
    activate: true,
    category: window.PMW.emails.blocks.CATEGORY_SECTIONS,
    label: window.i18next.t('pmwjs_section'),
    // trackingEvent: 'EmailMaker_AddSection', // Tracking temporarily disabled on 8th Nov 2023
    select: true,
    content: {
      type: window.PMW.emails.components.table.PMW_SECTION,
      [window.PMW.emails.props.COLUMNS_PRESET]: 4,
      [window.PMW.emails.props.APPLY_INITIAL_PRESET]: true,
    },
    attributes: {
      trackingEvent: 'EmailMaker_AddSection',
      sortPriority: 2,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_SECTION_PRESET_4, {
    activate: true,
    category: window.PMW.emails.blocks.CATEGORY_SECTIONS,
    label: window.i18next.t('pmwjs_section'),
    // trackingEvent: 'EmailMaker_AddSection', // Tracking temporarily disabled on 8th Nov 2023
    select: true,
    content: {
      type: window.PMW.emails.components.table.PMW_SECTION,
      [window.PMW.emails.props.COLUMNS_PRESET]: 8,
      [window.PMW.emails.props.APPLY_INITIAL_PRESET]: true,
    },
    attributes: {
      trackingEvent: 'EmailMaker_AddSection',
      sortPriority: 3,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_SECTION_PRESET_5, {
    activate: true,
    category: window.PMW.emails.blocks.CATEGORY_SECTIONS,
    label: window.i18next.t('pmwjs_section'),
    // trackingEvent: 'EmailMaker_AddSection', // Tracking temporarily disabled on 8th Nov 2023
    select: true,
    content: {
      type: window.PMW.emails.components.table.PMW_SECTION,
      [window.PMW.emails.props.COLUMNS_PRESET]: 9,
      [window.PMW.emails.props.APPLY_INITIAL_PRESET]: true,
    },
    attributes: {
      trackingEvent: 'EmailMaker_AddSection',
      sortPriority: 4,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_SECTION_PRESET_6, {
    activate: true,
    category: window.PMW.emails.blocks.CATEGORY_SECTIONS,
    label: window.i18next.t('pmwjs_section'),
    // trackingEvent: 'EmailMaker_AddSection', // Tracking temporarily disabled on 8th Nov 2023
    select: true,
    content: {
      type: window.PMW.emails.components.table.PMW_SECTION,
      [window.PMW.emails.props.COLUMNS_PRESET]: 11,
      [window.PMW.emails.props.APPLY_INITIAL_PRESET]: true,
    },
    attributes: {
      trackingEvent: 'EmailMaker_AddSection',
      sortPriority: 5,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_TABLE, {
    activate: true,
    label: window.i18next.t('pmwjs_table'),
    category: window.PMW.emails.blocks.CATEGORY_ELEMENTS,
    // trackingEvent: 'EmailMaker_AddTable', // Tracking temporarily disabled on 8th Nov 2023
    select: true,
    content: {
      type: window.PMW.emails.components.table.PMW_TABLE,
    },
    attributes: {
      trackingEvent: 'EmailMaker_AddTable',
      sortPriority: 8,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_DESIGN, {
    activate: true,
    label: window.i18next.t('pmwjs_my_designs'),
    category: window.PMW.emails.blocks.CATEGORY_MY_DESIGNS,
    // trackingEvent: 'EmailMaker_AddDesign', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddDesign',
      sortPriority: 3,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.graphic.PMW_DESIGN,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_UPLOAD_CONTENT, {
    activate: true,
    label: window.i18next.t('pmwjs_myuploads'),
    category: window.PMW.emails.blocks.CATEGORY_IMAGE,
    // trackingEvent: 'EmailMaker_AddImage', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddImage',
      sortPriority: 13,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.graphic.PMW_IMAGE,
      [window.PMW.emails.props.MEDIA_MODAL]: window.PMW.emails.mediaImageModal.MY_UPLOADS,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_EXPLORE_MEDIA, {
    activate: true,
    label: window.i18next.t('pmwjs_explore_media'),
    category: window.PMW.emails.blocks.CATEGORY_IMAGE,
    // trackingEvent: 'EmailMaker_AddImage', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddImage',
      sortPriority: 14,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.graphic.PMW_IMAGE,
      [window.PMW.emails.props.MEDIA_MODAL]: window.PMW.emails.mediaImageModal.EXPLORE_MEDIA,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_AI_IMAGES, {
    activate: true,
    label: window.i18next.t('pmwjs_ai_images_small_cap'),
    category: window.PMW.emails.blocks.CATEGORY_IMAGE,
    // trackingEvent: 'EmailMaker_AddImage', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddImage',
      sortPriority: 15,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.graphic.PMW_IMAGE,
      [window.PMW.emails.props.MEDIA_MODAL]: window.PMW.emails.mediaImageModal.AI_IMAGES,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_STICKER, {
    activate: true,
    label: window.i18next.t('pmwjs_sticker'),
    category: window.PMW.emails.blocks.CATEGORY_ELEMENTS,
    // trackingEvent: 'EmailMaker_AddSticker', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddSticker',
      sortPriority: 10,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.graphic.PMW_STICKER,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_VIDEO, {
    activate: true,
    label: window.i18next.t('pmwjs_video'),
    category: window.PMW.emails.blocks.CATEGORY_ELEMENTS,
    attributes: {
      trackingEvent: 'EmailMaker_AddVideo',
      sortPriority: 8,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.graphic.PMW_VIDEO,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_TEXT_PRESET_1, {
    label: window.i18next.t('pmwjs_normal_text'),
    category: window.PMW.emails.blocks.CATEGORY_TEXT,
    // trackingEvent: 'EmailMaker_AddText', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddText',
      sortPriority: 11,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.text.PMW_TEXT,
      style: {
        color: '#242424',
        display: 'block',
        padding: '10px',
        margin: '0',
        width: 'unset',
        'box-sizing': 'border-box',
        'word-break': 'break-word',
        'overflow-wrap': 'break-word',
        'letter-spacing': 'normal',
        'line-height': '20px',
        'font-family': 'Helvetica, sans-serif',
        opacity: '100%',
        'border-color': '#FFFFFF',
        'text-align': 'center',
        'font-size': '14px',
        'font-weight': 'normal',
      },
    },
  });

  bm.add(window.PMW.emails.blocks.ID_TEXT_PRESET_2, {
    label: window.i18next.t('pmwjs_title'),
    category: window.PMW.emails.blocks.CATEGORY_TEXT,
    // trackingEvent: 'EmailMaker_AddText', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddText',
      sortPriority: 12,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.text.PMW_TEXT,
      style: {
        color: '#242424',
        display: 'block',
        padding: '10px',
        margin: '0',
        width: 'unset',
        'box-sizing': 'border-box',
        'word-break': 'break-word',
        'overflow-wrap': 'break-word',
        'letter-spacing': 'normal',
        'line-height': '20px',
        'font-family': 'Helvetica, sans-serif',
        opacity: '100%',
        'border-color': '#FFFFFF',
        'text-align': 'center',
        'font-size': '20px',
        'font-weight': 'bold',
      },
    },
  });

  bm.add(window.PMW.emails.blocks.ID_BUTTON, {
    label: window.i18next.t('pmwjs_button'),
    // category: window.PMW.emails.blocks.CATEGORY_PRIMARY,
    category: window.PMW.emails.blocks.CATEGORY_ELEMENTS,
    select: true,
    // trackingEvent: 'EmailMaker_AddButton', // Tracking temporarily disabled on 8th Nov 2023 - Renabled Aug 30
    attributes: {
      trackingEvent: 'EmailMaker_AddButton',
      sortPriority: 6,
    },
    content: {
      type: window.PMW.emails.components.text.PMW_BUTTON,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_SOCIAL, {
    label: window.i18next.t('pmwjs_social'),
    category: window.PMW.emails.blocks.CATEGORY_ELEMENTS,
    select: true,
    // trackingEvent: 'EmailMaker_AddSocial', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddSocial',
      sortPriority: 9,
    },
    content: {
      type: window.PMW.emails.components.social.PMW_SOCIALS,
    },
  });

  bm.add(window.PMW.emails.blocks.ID_DIVIDER, {
    label: window.i18next.t('pmwjs_divider'),
    category: window.PMW.emails.blocks.CATEGORY_ELEMENTS,
    // trackingEvent: 'EmailMaker_AddDivider', // Tracking temporarily disabled on 8th Nov 2023
    attributes: {
      trackingEvent: 'EmailMaker_AddDivider',
      sortPriority: 7,
    },
    select: true,
    content: {
      type: window.PMW.emails.components.misc.PMW_DIVIDER,
    },
  });
};
